@if (shouldShowDropdown()) {
  <div [class.mb-6]="!compact()" data-testid="evaluation-contributor-filter-dropdown">
    @if (!compact()) {
      <label for="evaluation-contributor-dropdown" class="block text-sm font-medium mb-2">
        {{ 'project.steps.contributor.filterByUser' | transloco }}
      </label>
    }
    <p-select
      inputId="evaluation-contributor-dropdown"
      [options]="contributorOptions()"
      [ngModel]="selectedContributorEmail()"
      optionValue="value"
      [placeholder]="'project.steps.contributor.selectUser' | transloco"
      [disabled]="loading()"
      (ngModelChange)="onContributorChange($event)"
      class="w-full"
    >
      <ng-template #item let-option>
        <div [attr.data-testid]="'evaluation-contributor-option-' + option.value">
          @if (option.label.startsWith('project.steps.')) {
            {{ option.label | transloco }}
          } @else {
            {{ option.label }}
          }
        </div>
      </ng-template>
      <ng-template #selectedItem let-option>
        <div [attr.data-testid]="'selected-evaluation-contributor-' + option.value">
          @if (option && option.label.startsWith('project.steps.')) {
            {{ option.label | transloco }}
          } @else {
            {{ option?.label }}
          }
        </div>
      </ng-template>
    </p-select>
  </div>
}
